import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, switchMap, tap } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { DocumentStatus, TemplateDocumentType } from '../../models/document/document-template-model';
import { MyfileSearchModel } from '../../models/myfile/myfile-search.model';
import { MyfileModel } from '../../models/myfile/myfile.model';
import { SearchResultModel } from '../../models/query/search-result-model';
import { MyfileApiService } from '../myfile-api.service';
import { BaseListService } from './base-list.service';


@Injectable({
  providedIn: 'root'
})
export class MyfileListService extends BaseListService {

  private _myfiles$ = new BehaviorSubject<MyfileModel[]|undefined>([]);


  myfiles?: any;

  defaultMyfileListState: MyfileSearchModel = {
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    startIndex: 1,
    sortColumn: '',
    sortDirection: '',
    sortColumnDirective: '',
    sortDirectionDirective: '',
    searchTerm: undefined,
    status: undefined,
    types: undefined,
    sourceId: "",
    pageIndex: 0,
  };

  protected override _state: MyfileSearchModel = { ...this.defaultMyfileListState };

  constructor(public ApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe(result => {
      if (result) {
        if (result.count > 0) {
          this._myfiles$.next(result.items);
        } else {
          this._myfiles$.next(undefined);
        }
        this._total$.next(result.count);
      }
    });
  }

  get myfiles$() { return this._myfiles$.asObservable(); }
  get sourceId() { return this._state.sourceId!; }

  set status(status: DocumentStatus) { this._set({ status }); }
  set sourceId(sourceId: string) { this._set({ sourceId }); }
  set types(types: TemplateDocumentType[] | undefined) { this._setNoSearch({ types }); }

  public clearSourceId() {
    this._myfiles$ = new BehaviorSubject<MyfileModel[]|undefined>([]);
    this._total$ = new BehaviorSubject<number>(0);
    this.startIndexNoSearch = 1;
  }

  protected _search(): Observable<SearchResultModel<MyfileModel> | undefined> {
    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.ApiService.getMyFileList(this._state);
  }

  override clearListService(): void {

  }


}